import $ from 'jquery';
import '/src/js/app.externalfunding.js'
import '/src/js/app.edmpopup.js'
import '/src/js/app.resourceForm.js'
import '/src/js/app.principles.js'
import '/src/js/app.sectorjobs.js'
import '/src/js/app.elmoiframe.js'
import valid from 'jquery-validation';

$(document).ready(function () {
    //$(document).ready(function () {
    var $root = $('html, body');
    var isIE = /MSIE|Trident/.test(window.navigator.userAgent);

    // fix missing forEach on NodeList for IE11
    if (isIE) {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }
    }


    // Featured Nav
    function openFeaturedNavDropdown() {
        $('#featured-nav-dropdown-toggle').addClass('open');
        $('#featured-nav-dropdown').addClass('open');
        $('#menu-underlay').addClass('active');
    }
    function closeFeaturedNavDropdown() {
        $('#featured-nav-dropdown-toggle').removeClass('open');
        $('#featured-nav-dropdown').removeClass('open');
        $('#menu-underlay').removeClass('active');
    }

    if ($('#featured-nav-dropdown').length !== 0) {

        // Hover over link to open dropdown
        $('#featured-nav-dropdown-toggle').on('mouseenter', function () {
            openFeaturedNavDropdown();
        });
        $('#featured-nav-dropdown').on('mouseleave', function () {
            if (!$('#featured-nav-dropdown-toggle').hasClass('stay-open')) {
                closeFeaturedNavDropdown();
            }
        });

        // Click on link to keep dropdown open, click again to close it 
        $('#featured-nav-dropdown-toggle').on('click', function () {
            if (!$(this).hasClass('stay-open')) {
                openFeaturedNavDropdown();
                $(this).addClass('stay-open');
            } else {
                closeFeaturedNavDropdown();
                $(this).removeClass('stay-open');
            }
        });

        // Close dropdown on menu underlay click
        $('#menu-underlay').on('click', function () {
            $('#featured-nav-dropdown-toggle').removeClass('stay-open');
            closeFeaturedNavDropdown();
        })
    }

    // Burger Nav (Main Nav)
    if ($('.burger-toggle').length !== 0 && $('#burger-menu').length !== 0) {
        $('.burger-toggle').on('click', function () {
            $(this).toggleClass('burger-toggle-open');
            $('#burger-menu').toggleClass('open');
            $('#page-header').toggleClass('burger-menu-open');

            // ensure featured nav is closed
            closeFeaturedNavDropdown();
        });
    }

    // Featured and Burger nav close using escape key
    document.onkeydown = function (e) {
        e = e || window.event;
        if (e.keyCode == 27) {
            closeFeaturedNavDropdown();
            $('.burger-toggle').removeClass('burger-toggle-open');
            $('#burger-menu').removeClass('open');
            $('#page-header').removeClass('burger-menu-open');
        }
    };

    // Browse menu top corner colour
    if ($('#browse').find('.browse-menu').length !== 0) {
        let firstLink = $('#browse').find('.browse-menu li:first-child a');
        let browseSection = $('#browse').find('.browse-section');
        if ($(firstLink).hasClass('current-page')) {
            $(browseSection).addClass('first-item-active');
        } else {
            $(firstLink).hover(function () {
                $(browseSection).addClass('first-item-active');
            }, function () {
                $(browseSection).removeClass('first-item-active');
            });
        }
    }

    // convert svg image to inline svg (doesn't work in IE)
    if (!isIE) {
        if ($('img.inline-svg').length !== 0) {
            const convertImages = function (query, callback) {
                const images = document.querySelectorAll(query);

                images.forEach(function (image) {
                    fetch(image.src)
                        .then(function (res) { return res.text() })
                        .then(function (data) {
                            const parser = new DOMParser();
                            const svg = parser.parseFromString(data, 'image/svg+xml').querySelector('svg');

                            if (image.id) svg.id = image.id;
                            if (image.className) svg.classList = image.classList;
                            if (image.title) svg.title = image.title;

                            image.parentNode.replaceChild(svg, image);
                        })
                        .then(callback)
                });
            }
            convertImages('img.inline-svg');
        }
    }

    // Accordion toggle
    $('.accordion-item-heading').on('click', function () {
        $(this).toggleClass('active');
    })
    $('.burger-accordian-item-heading').on('click', function () {
        $(this).toggleClass('active');
    })

    // Campaign tabs (e.g. Further Resources block) - Bootstrap's tab JS is not loaded on the site
    $(document).on('click', '.campaign-tabs .nav-link[data-target]', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $tabs = $btn.closest('.campaign-tabs');
        var $target = $tabs.find($btn.data('target'));
        if ($target.length === 0) { return; }

        $tabs.find('.nav-link').removeClass('active').attr('aria-selected', 'false');
        $btn.addClass('active').attr('aria-selected', 'true');

        $tabs.find('.tab-pane').removeClass('show active');
        $target.addClass('show active');
    });


    // Scroll to ID (doesn't work in IE)
    if (!isIE) {
        document.querySelectorAll('a[href^="#"]:not([data-fancybox])').forEach(function (anchor) {
            anchor.addEventListener('click', function (e) {
                var target = $.attr(this, 'href').substr(1);
                if (!target) { return; }
                
                var $target = $('[name="' + target + '"]')[0] ? $('[name="' + target + '"]') : $('[id="' + target + '"]');
                if ($target && $target.length !== 0) {
                    e.preventDefault();
                    $root.animate({
                        scrollTop: $target.offset().top - 75 - 60
                    }, 300);
                    return false;
                }
            });
        });
    }

    // Anchor Link Offset
    $(window).on('load', function () {
        if (location.hash.length === 0) { return; }
        var target = location.hash.replace('#', '');
        var selector = $('[name="' + target + '"]')[0] ? '[name="' + target + '"]' : '[id="' + target + '"]';
        if (!$(selector)[0]) { return; }
        var attempts = 0, lastTop = -1;
        (function settleScroll() {
            var top = Math.round($(selector).offset().top - 75 - 60);
            if (top !== lastTop) {
                lastTop = top;
                $root.stop().animate({ scrollTop: top }, 200);
            }
            if (++attempts < 8) { setTimeout(settleScroll, 200); }
        })();
    });

    $(".article-card").slice(0, 12).show();

    if ($(".article-card:hidden").length == 0) {
        $("#load-more").remove();
    }

    $("#load-more").on('click', function (e) {
        e.preventDefault();
        $(".article-card:hidden").slice(0, 12).show();
        if ($(".article-card:hidden").length == 0) {
            $("#load-more").remove();
        }
    });

    function keyPress(e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`
            $('#user-feedback-toggle').trigger('click');
            $(document).unbind("keyup", keyPress);
        }
    }

    // User feedback toggle
    $('#user-feedback-toggle').on('click', function () {
        $('#user-feedback').toggleClass('open');
        $(document).keyup(keyPress);
    });

    // User feedback hide on mobile when scrolling down
    if (window.innerWidth < 768 && $('#user-feedback').length !== 0) {
        var lastScrollTop = 0;
        $(window).scroll(function () {
            if (!$('#user-feedback').hasClass('open')) {
                var st = $(this).scrollTop();
                setTimeout(function () {
                    if (st > lastScrollTop + 5) {
                        // downscroll code
                        $('#user-feedback').addClass('hidden');
                    } else if (st < lastScrollTop - 15) {
                        // upscroll code
                        $('#user-feedback').removeClass('hidden');
                    }
                    lastScrollTop = st;
                }, 150);
            }
        });
    }

    // page refresh
    $('#location-reload').on('click', function () {
        window.history.replaceState(null, null, window.location.pathname);
        location.reload();
    });

    // Add rel="noopener" to external links for security
    function noopenerToExternalLinks() {
        $('a[href^="http"]').not('a[href*="' + location.hostname + '"]').attr({ target: "_blank", rel: "noopener" });
    }
    noopenerToExternalLinks();

    addQueryStringToUrl();

    showSiteSearchResult();

    // Onload
    window.onload = function () {

        // Match card heights
        if ($('.cards').length !== 0) {
            matchCardHeights();
        }

        // Mailchimp user feedback form - iframe src
        if ($('#user-feedback-form-iframe').length !== 0) {
            setTimeout(function () {
                document.getElementById('user-feedback-form-iframe').src = 'https://us6.list-manage.com/survey?u=ef741df6f3215cebd8c693760&id=66060bb7d3';
            }, 1000);
        }

    } // end window.onload

    if ($("#find-sport-search-results").children().length > 0) {
        $("#clear-search-form").addClass('show');
        $("#GridContent").remove();
    }

}); // End $(document).ready

// Remove components content after Search
function articleSearchCallBack() {
    $("#GridContent").remove();
    $(".article-card").slice(0, 12).show();
    $("#clear-search-form").addClass('show');

    if ($(".article-card:hidden").length == 0) {
        $("#load-more").remove();
    }

    matchCardHeights();

    $("#load-more").on('click', function (e) {
        e.preventDefault();
        $(".article-card:hidden").slice(0, 12).show();
        if ($(".article-card:hidden").length == 0) {
            $("#load-more").remove();
        }
    });

    $('#location-reload').on('click', function () {
        window.history.replaceState(null, null, window.location.pathname);
        location.reload();
    });

    addQueryStringToUrl();
}
window.articleSearchCallBack = articleSearchCallBack;


// Match card height
function matchCardHeights() {
    if (window.innerWidth >= 992) {
        $('.cards:not(.no-match-card-height)').each(function () {
            const heights = [];
            $('.card', this).each(function () {
                heights.push($(this).outerHeight());
            })
            const tallestCardHeight = Math.max.apply(Math, heights);
            $('.card', this).css('min-height', tallestCardHeight);
        });
    }
}
window.matchCardHeights = matchCardHeights;

function siteSearchCallBack() {
    showSiteSearchResult();
    matchCardHeights();
    addQueryStringToUrl();
}
window.siteSearchCallBack = siteSearchCallBack;

function addQueryStringToUrl() {
    $("#query-string-search").submit(function () {
        var form = $(this).closest('form');

        var formData = new FormData(form[0]);
        formData.delete('__RequestVerificationToken');
        formData.delete('ufprt')

        var queryData = new URLSearchParams(formData).toString().toLowerCase();
        history.pushState("", "", "?" + queryData);
    })
}
window.addQueryStringToUrl = addQueryStringToUrl;

function showSiteSearchResult() {
    if ($("#site-search-text").val()) {
        $("#section-search-form").removeClass("before-search-submit");
    }

    $(".resource-card").slice(0, 4).show();
    $(".news-card").slice(0, 4).show();
    $(".document-card").slice(0, 4).show();
    $(".page-card").slice(0, 4).show();
    $(".archived-card").slice(0, 4).show();

    if ($(".resource-card:hidden").length == 0) {
        $("#resource-loadmore").remove();
    }

    if ($(".news-card:hidden").length == 0) {
        $("#news-loadmore").remove();
    }

    if ($(".document-card:hidden").length == 0) {
        $("#document-loadmore").remove();
    }

    if ($(".page-card:hidden").length == 0) {
        $("#page-loadmore").remove();
    }

    if ($(".archived-card:hidden").length == 0) {
        $("#archived-loadmore").remove();
    }

    $("#resource-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".resource-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".resource-card:hidden").length == 0) {
            $("#resource-loadmore").remove();
        }
    });

    $("#document-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".document-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".document-card:hidden").length == 0) {
            $("#document-loadmore").remove();
        }
    });

    $("#news-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".news-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".news-card:hidden").length == 0) {
            $("#news-loadmore").remove();
        }
    });

    $("#page-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".page-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".page-card:hidden").length == 0) {
            $("#page-loadmore").remove();
        }
    });

    $("#archived-loadmore").on('click', function (e) {
        e.preventDefault();
        $(".archived-card:hidden").slice(0, 12).show();
        matchCardHeights();
        if ($(".archived-card:hidden").length == 0) {
            $("#archived-loadmore").remove();
        }
    });
}

// SKIP TO CONTENT
var initialLoad = true;
var tabIndex = 0;

$(document).ready(function () {
    $(document).on('keyup', function (e) {
        if (e.which === 9) {
            if (tabIndex === 0 && window.scrollY === 0 && initialLoad) {
                $(this).blur();
                e.preventDefault();
                $('#screen-reader-skip').addClass('active');
                $('#screen-reader-skip').focus();
                tabIndex++;
            } else {
                $('#screen-reader-skip').removeClass('active');
            }

            initialLoad = false;
        }
    });

    $('#screen-reader-skip').on('keyup click', function (e) {
        $($("[name='screen-reader-scroll-point']").find('a')[0]).focus();
        $('#screen-reader-skip').removeClass('active');
        tabIndex = 0;
    });

    $('#screen-reader-skip').blur(function () {
        $('#screen-reader-skip').removeClass('active');
    });

    $('#contactForm').submit(function (event) {
        if ($('#contactForm').valid()) {
            if (!grecaptcha.getResponse()) {
                event.preventDefault(); //prevent form submit
                grecaptcha.execute();
            }
        }
    });
    $(document).on("click", ".js-find-resources", function (e) {
        var urlEncoded = $('.section-resource-search__form select').map(function () {
            return encodeURIComponent(this.name) + '=' + encodeURIComponent($(this).val());
        }).get().join('&');
        var currentPageId = $('#CurrentPageId').val();
        var resourcesUrl = $(this).data("resourcesurl")
        var hideCategory = $(this).data("hidecategory")
        var hideRole = $(this).data("hiderole")
        var hideResourceType = $(this).data("hideresourcetype")

        resourcesUrl = `${resourcesUrl}?${urlEncoded}&currentpageid=${currentPageId}&hidecategory=${hideCategory}&hiderole=${hideRole}&hideresourcetype=${hideResourceType}`;
        window.location.href = resourcesUrl;
    });
    $(document).on("change", ".formDropdown", function (e) {
        e.preventDefault();
        var form = $(this).closest('form[data-ajax=true]');
        var submitBtn = form.find('input[type="submit"]');
        $(submitBtn).click();
        $("#GridContent").remove();
    });
});

function beginSubmitForm() {
    let valid = $('#TopicName')[0]?.value !== '' || $('#RoleName')[0]?.value !== '' || $('#ResourceType')[0]?.value !== '' || $('#SearchTerm')[0].value !== '';

    if (!valid) {
        $('#GlobalResourceFormSubmissionError').show();
    } else {
        $('#GlobalResourceFormSubmissionError').hide();
    }

    return valid;
}
window.beginSubmitForm = beginSubmitForm;


function onFormSubmit(token) {
    return new Promise(function (resolve, reject) {
        document.getElementById("contactForm").submit.click();
        resolve();
    });
}
window.onFormSubmit = onFormSubmit;